module.exports = __webpack_public_path__ + "img/radio.ce875db7.png";